import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorPage: React.FC = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div
            className="flex items-center justify-center min-h-screen 
    bg-gradient-to-r from-rose-100 to-teal-100"
        >
            <div className="text-center">
                <h1 className="text-8xl font-bold text-red-600">404!</h1>
                <p className="text-3xl text-gray-700 mt-4">
                    Oops! Page not found.
                </p>
                <button
                    data-testid="error-page-go-home-button"
                    onClick={handleGoHome}
                    className="mt-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                    <p className=" text-2xl font-sans">Go Home</p>
                </button>
            </div>
        </div>
    );
};

export default ErrorPage;
